import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {StepScreenModel} from '../../../shared/step/step-screen.component';
import {FormErrors} from '../../../../components/forms/validation/form-validator.class';
import {CountryService} from '../../../../domain/model/info/country/country.service';
import {Residency} from '../../../../domain/model/education/residency/residency.model';
import {ResidencyService} from '../../../../domain/model/education/residency/residency.service';
import {FileLocation, FileLocationFactory} from '../../../../components/files/service/file-location.class';
import {Model} from '../../../../domain/model/common/model.class';
import {MonthPickerComponentModel} from '../../../../components/forms/controls/monthpicker/month-picker.component';
import {AddressModel} from '../../../../components/forms/controls/addresspicker/addresspicker.component';
import {AddressMapper} from '../../../../domain/model/common/mappers/address-mapper.class';
import {ActivatedRoute} from '@angular/router';
import {ResidencyScreensManager} from './residency-screens-manager.service';
import {PlaceInfoService} from '../../../../domain/model/info/place/place-info.service';
import {PlaceInfo} from '../../../../domain/model/info/place/place-info.model';
import {State} from '../../../../domain/model/info/country/state.model';
import moment = require('moment');
import ProjectionInformation = Model.ProjectionInformation;
import {VerificationService} from '../../../../components/verification/service/verification.service';

@Component({
    template: require('./residency-screen.component.html')
})
export class ResidencyScreenComponent {

    constructor(readonly educationService: ResidencyService,
                countryService: CountryService,
                placeInfoService: PlaceInfoService,
                readonly route: ActivatedRoute,
                readonly screensManager: ResidencyScreensManager,
                readonly fileLocationFactory: FileLocationFactory,
                readonly verificationService: VerificationService) {

        countryService.getCountriesProjection().subscribe(countries => this.countries = countries.map(c => c.name));
        countryService.getStates().subscribe(states => {
            this.states = states;
            this.stateValues = states.map(s => s.name);
        });

        placeInfoService.getPlaces().subscribe(schools => {
            this.schools = schools;
            this.schoolValues = schools.map(s => s.name);
        });
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    private readonly _addressMapper = new AddressMapper();

    countries: Array<string> = [];
    states: Array<State> = [];
    stateValues: Array<string> = [];
    schools: Array<PlaceInfo> = [];
    schoolValues: Array<string> = [];
    phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    attendanceDateConstrains = {
        minDate: moment().subtract(100, 'year'),
        maxDate: moment().add(5, 'year')
    };
    attendanceFromMonthPickerModel = new MonthPickerComponentModel(this.attendanceDateConstrains);
    attendanceToMonthPickerModel = new MonthPickerComponentModel(this.attendanceDateConstrains);
    proofDocumentFileLocation: FileLocation;

    get index(): number {
        return +this.route.snapshot.params['index'];
    }

    stepScreenModel = new StepScreenModel<Residency>({
        initialDataModel: new Residency(),
        specificValidationMessages: {},
        screensManager: this.screensManager,
        _loadDataFn: () => {
            this.proofDocumentFileLocation = this.fileLocationFactory.create('residency', `currentUser/${this.index}`, new ProjectionInformation('proofDocument'));
            this.verificationService.setUrl('residency', undefined, `${this.index}`);
            return this.educationService.getCurrentUserModelEntry(this.index);
        },
        _submitDataFn: (model: Residency) => {
            return this.educationService.updateCurrentUserModelEntry(this.index, model);
        },
        _hasYesNoQuestion: () => this.educationService.doesCurrentUserModelEntryExist(this.index).map(r => !r)
    });

    get model(): Residency {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }

    handleAddressUpdated(addressModel: AddressModel) {
        this._addressMapper.update(this.model.address, addressModel);
    }

    get medicalSchool(): string | undefined { return this.model.institution; }

    set medicalSchool(name: string | undefined) {
        this.model.institution = name;

        const school = this.schools.find(s => s.name === name);
        if (school) {
            this.model.address.address1 = school.address1;
            this.model.address.postalCode = school.postalCode;
            this.model.address.city = school.city;
            this.model.address.stateOrProvince = this._getStateName(school.stateOrProvince);
            this.model.address.country = school.country;
            this.model.contact.phone = school.phone;
            this.model.contact.fax = school.fax;
        }
    }

    private _getStateName(code: string): string | undefined {
        const state = this.states.find(s => s.code === code);
        if (state) return state.name;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/education/steps/residency/residency-screen.component.ts